import React from 'react';
import { images } from '../assets/images';
import Advantages from '../components/Advantages';
import ContactUs from '../components/ContactUs';
import FeaturedSection from '../components/FeaturedSection';
import './BOXi.css';

function BOXi() {
  return (
    <div className="BOXi">
      <div className='BOXi_hero'>
        <div className='column-left'>
        <h1 className='title desktop'>The technology to&nbsp;<strong>pay&nbsp;cashless</strong><br className="full-width-breakpoint"/> at&nbsp;vending machines</h1>
        <h1 className='title mobile'>The technology to pay <strong>cashless</strong> at vending machines</h1>
        <p className='align-left'>A PCI board with proprietary software that allows connectivity and mobile payments to any kind of unattended retail machine and offers advanced telemetry and data analysis tools.</p>
        </div>
        <div className='column-right'>
        <img src={require('../assets/boxi-vending-board-app.png')}/>
        </div>
      </div>
      <section className='telemetry'>
        <div className='text'>
          <h2>Real-time telemetry</h2>
          <p>Thanks to the Dashboard, vending operators can monitor both cash and cashless purchases, analyse machines’ performances, start marketing initiatives, and manage support requests.</p>
        </div>
        <div className='imgs'>
          <img id="imgs-1" src={images.widgetcart}/>
          <img id="imgs-2" src={images.widgetrevenue}/>
          <img id="imgs-3" src={images.widgettraded}/>
        </div>
      </section>
      <section className='cashback'>
        <div className='imgs'>
          <img src={images.cashback}/>
        </div>
        <div className='text'>
          <h2>Promotions to boost sales</h2>
          <p>Thanks to the Dashboard, vending operators can monitor both cash and cashless purchases, analyse machines’ performances, start marketing initiatives, and manage support requests.</p>
        </div>
      </section>
      <section className='board'>
        <div className='imgs'>
          <img src={images.case}/>
        </div>
        <div className='text'>
          <h2>Electronic Board</h2>
          <p>It connects the vending machine to the internet and, therefore, to our management platform on the Cloud, allowing thus remote control, while receiving real-time data.</p>
        </div>
      </section>
      <Advantages
      title="Why BOXi Vending?"
      img1={images.case}
      img2={images.case}
      img3={images.case}
      text1="More purchase opportunites"
      text2="Real-time telemetry"
      text3="Marketing initiatives"
      color="#f9f9f9"
      ></Advantages>
      <FeaturedSection
      title='Industry 4.0 compliance'
      subtitle='BOXi Vending is compliant with Industry 4.0 fiscal advantages, backed by Italian Ministry of Economy'
      button='Discover more'
      img={images.industria40}></FeaturedSection>
      <ContactUs
      title="Contact us"
      subtitle="We are open to give you further details about BOXi"
      button="Leave a message"
      ></ContactUs>
    </div>
  );
}

export default BOXi;
